const isDevEnv =
  process.env.REACT_APP_ENV === "dev" ||
  process.env.NODE_ENV === "development";

/**
 * Timer-based REST polling (unread-count, conversation list every N seconds).
 * Acts as a safety net so notifications keep updating if BOTH the WebSocket and
 * Firebase realtime channels fail. WebSocket/Firebase remain the primary path.
 */
export const REALTIME_POLLING_ENABLED = true;

/** Refetch REST data when a WebSocket or Firebase event arrives. Keep ON. */
export const REALTIME_REST_SYNC_ENABLED = true;

/** Console logs for STOMP connect, events, and errors — dev only. */
export const REALTIME_DEBUG_LOG = isDevEnv;
